import { render, staticRenderFns } from "./ShippingCompany.vue?vue&type=template&id=83b1ec96&scoped=true"
import script from "./ShippingCompany.vue?vue&type=script&lang=js"
export * from "./ShippingCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b1ec96",
  null
  
)

export default component.exports